import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVeepeeComponent } from './simple-icons-veepee.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVeepeeComponent ],
    exports:      [ SimpleIconsVeepeeComponent ],
    bootstrap:    []
})
export class SimpleIconsVeepeeModule {}
